<template>
  <div
    @mouseenter="() => {
      hover = true;
      useDebounceFn(() => {
        hover && (show = true);
      }, 500)()
    }"
    @mouseleave="() => {
      hover = false;
      useDebounceFn(() => {
        !hover && (show = false);
      }, 100)()
    }"
  >
    <slot :show="show" />
  </div>
</template>
<script setup>
import { ref } from 'vue';
import { useDebounceFn } from '@vueuse/core';

const hover = ref(false);
const show = ref(false);

</script>
